import { createApp } from 'vue'
import App from './App.vue'
import './assets/style.scss' // Додайте цей імпорт

createApp(App).mount('#app')
